import script from "./CheckinsFeedLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinsFeedLoader.vue?vue&type=script&setup=true&lang=js"

import "./CheckinsFeedLoader.vue?vue&type=style&index=0&id=e0473236&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0473236"]])

export default __exports__